var _path;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgJoinedMatchGray = function SvgJoinedMatchGray(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 14.8333L2.15812 16.2807C1.83435 16.3886 1.5 16.1476 1.5 15.8062V3.52705C1.5 3.31183 1.63772 3.12076 1.84188 3.05271L6.5 1.5M6.5 14.8333L11.5 16.5M6.5 14.8333V1.5M11.5 16.5L16.1581 14.9473C16.3623 14.8793 16.5 14.6882 16.5 14.4729V2.19372C16.5 1.85243 16.1657 1.61145 15.8419 1.71938L11.5 3.16667M11.5 16.5V3.16667M11.5 3.16667L6.5 1.5",
    stroke: "#8a9fc7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgJoinedMatchGray, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/joinedMatchGray.a02ca9b1.svg";
export { ForwardRef as ReactComponent };